import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { NotificationsEffects } from './state/notifications.effects';
import { NotificationsFacade } from './state/notifications.facade';
import { featureKey, reducer } from './state/notifications.reducer';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(featureKey, reducer),
        EffectsModule.forFeature([NotificationsEffects])
    ],
    providers: [NotificationsFacade]
})
export class NotificationsDomainModule {}
